// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"330c1f1d","462":"f2ee1cf8","870":"4a73a52e"}[chunkId] + ".chunk.js";
};